import { render, staticRenderFns } from "./pageFestival.vue?vue&type=template&id=81175e06&scoped=true"
import script from "./pageFestival.vue?vue&type=script&lang=js"
export * from "./pageFestival.vue?vue&type=script&lang=js"
import style0 from "./pageFestival.vue?vue&type=style&index=0&id=81175e06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81175e06",
  null
  
)

export default component.exports